import { Children, isValidElement, type ReactElement, type ReactNode } from "react";

export interface FrameSlots {
  background?: ReactElement;
  topBar?: ReactElement;
  leftPane?: ReactElement;
  content?: ReactElement;
  rightPane?: ReactElement;
  footer?: ReactElement;
  bottomBar?: ReactElement;
  alerts?: ReactElement;
  overlay?: ReactElement;
}

export interface SlotComponentMap {
  Background: unknown;
  TopBar: unknown;
  LeftPane: unknown;
  Content: unknown;
  RightPane: unknown;
  Footer: unknown;
  BottomBar: unknown;
  Alerts: unknown;
  Overlay: unknown;
}

/**
 * Walk Frame's direct children once, matching each child against the slot
 * component identities, and return a slot map. Only direct children are
 * inspected — slots nested inside arbitrary wrappers won't be detected, by
 * design (the slot is the boundary).
 */
export function useFrameSlots(children: ReactNode, components: SlotComponentMap): FrameSlots {
  const slots: FrameSlots = {};

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) return;
    const type = child.type;

    if (type === components.Background) slots.background = child;
    else if (type === components.TopBar) slots.topBar = child;
    else if (type === components.LeftPane) slots.leftPane = child;
    else if (type === components.Content) slots.content = child;
    else if (type === components.RightPane) slots.rightPane = child;
    else if (type === components.Footer) slots.footer = child;
    else if (type === components.BottomBar) slots.bottomBar = child;
    else if (type === components.Alerts) slots.alerts = child;
    else if (type === components.Overlay) slots.overlay = child;
  });

  return slots;
}
